module.exports = __webpack_public_path__ + "assets/pickup-bf618f.svg";